export const BladeColors = [
  "#F20000", // red
  "#BF40BF", // purple
  "#FEFE00", // yellow
  "#F79807", // orange
  "#00FF00", // green
  "#0000FF", // blue
];

export const HiltColors = ["#CDCDCD", "#F5D317", "#000000"];

export const RobeColors = [
  "#FFFFFF", // white
  "#AB9B69", // grey
  "#9C7600", // tan
  "#7D1616", // red
  "#16337D", // blue

  "#000000", // black
];

export const EyeColors = [
  "#FFFFFF", // white
  "#3498DB", // blue
  "#52BE80", // green
  "#D4AC0D", // hazel
  "#A04000", // brown
  "#C40505", // red
];

export const SkinColors = [
  "#FAE9B3", //
  "#CF9B00", //
  "#5A4402", //
  "#DB0000", // red
  "#27FE00", // green
  "#1902FF", // blue
];

export const BackgroundColors = [
  "#101093", // blue
  "#390101", // red
];

export default BladeColors;
